import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: 'La commande prendra-t-elle plus/moins de temps ?',
  text: {
    [OrderMethod.Pickup]:
      "Le client attend sa commande prête pour le retrait <strong>{{date}}</strong> à <strong>{{time}}</strong><br/> Si nécessaire, vous pouvez modifier l'heure ici.",
    [OrderMethod.OnSite]:
      "Le client attend sa commande prête pour le retrait <strong>{{date}}</strong> à <strong>{{time}}</strong><br/> Si nécessaire, vous pouvez modifier l'heure ici.",
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        "Le client attend la livraison <strong>{{date}}</strong> à <strong>{{time}}</strong><br/> Si nécessaire, vous pouvez modifier l'heure ici.",
      [DeliveryMode.External]: 'Le livreur viendra chercher la commande à <strong>{{time}}{{confidenceLabel}}</strong>',
    },
  },
  labels: {
    today: "Aujourd'hui",
  },
  confidence_labels: {
    estimated: ' (estimé !)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Confirmer la nouvelle heure de retrait',
    confirm_delivery: 'Confirmer la nouvelle heure de livraison',
  },
  confirmation_modal: {
    description: "Êtes-vous sûr de vouloir modifier l'heure de {{currentPickupTime}} à {{newPickupTime}} ?",
    ok_button_text: 'Confirmer la nouvelle heure',
    cancel_button_text: "Non, revenir à l'heure d'origine",
  },
};
